/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Displayname1Inputs */

const en_entity_displayname1 = /** @type {(inputs: Entity_Displayname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Name`)
};

const de_entity_displayname1 = /** @type {(inputs: Entity_Displayname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Display Name" |
*
* @param {Entity_Displayname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_displayname1 = /** @type {((inputs?: Entity_Displayname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Displayname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_displayname1(inputs)
	return de_entity_displayname1(inputs)
});
export { entity_displayname1 as "entity_displayName" }